import { get } from 'lodash-es';
import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { baseColumnsDefaultConfigs, defaultColumnConfigurations } from '../../../store/returns/grid/default-column-configuration';
import { emptyArray } from 'ui-components/default-props/empty';
import { GridConfigService } from '../../../services/grid-config-service';
import { ReturnsGridModes } from '../../../enums/returns-grid-mode';

export const selectReturns = (state) => get(state, 'returns');
export const selectPage = (state) => get(state, 'page');
export const selectPageSize = (state) => get(state, 'pageSize');
export const selectTotalRecords = (state) => get(state, 'totalRecords');
export const selectTotalPages = (state) => get(state, 'totalPages');
export const selectViewStartingCount = (state) => get(state, 'viewStartingCount');
export const selectViewEndingCount = (state) => get(state, 'viewEndingCount');
export const selectIsLoading = (state) => get(state, 'isLoading');

const noReceivedDateColumnSelector = createSelector(
  (baseCols) => baseCols,
  (baseCols) => {
    const noReceivedDate = baseCols.filter((col) => col.id !== 'received-date');

    if (noReceivedDate.length === 0) {
      return emptyArray;
    }

    return noReceivedDate;
  },
);

// Second input is used only as a cache key discriminator (one entry per statusViewId + mode)
const mergedConfigurationSelector = createCachedSelector(
  (viewConfiguration) => viewConfiguration,
  (_, cacheKey) => cacheKey,
  (viewConfiguration) => GridConfigService.mergeUserAndDefaultConfigs(viewConfiguration, defaultColumnConfigurations),
)((_, cacheKey) => cacheKey);

export const selectUserGridConfigOrDefault = (state, { statusViewId, mode = ReturnsGridModes.Shipment }) => {
  const savedConfig = get(state, `columnConfiguration.${statusViewId}.${mode}`);

  if (savedConfig) {
    return mergedConfigurationSelector(savedConfig, `${statusViewId}_${mode}`);
  }

  return noReceivedDateColumnSelector(baseColumnsDefaultConfigs);
};

export const selectCurrentOrderByColumn = (state, { statusViewId, mode = ReturnsGridModes.Shipment }) => {
  const gridConfig = selectUserGridConfigOrDefault(state, { statusViewId, mode }) || emptyArray;
  return gridConfig.find((col) => !!col.sorted);
};
